var _ = require('lodash');
var esUtils = require('../utils/esUtils');

var doAjax = function(method, url, post_body, callback, onProgress, timeout){
	method = _.includes(['GET', 'POST'], method) ? method : 'GET';
	callback = _.isFunction(callback) ? callback : _.noop;
	timeout = _.isNumber(timeout) && timeout > 0 ? timeout : 3 * 60 * 1000;

	var xhr = (window.ActiveXObject) ? new ActiveXObject("Microsoft.XMLHTTP") : (XMLHttpRequest && new XMLHttpRequest()) || null;
	if(!xhr){
		callback('NO AJAX', null, -1, null);
		return null;
	}
	var requestTimeout = setTimeout(function(){
		xhr.abort();
		callback('ajax timed out', null, -1, xhr);
	}, timeout);
	xhr.onreadystatechange = function(){
		if(xhr.readyState == 4){
			clearTimeout(requestTimeout);
			callback(null, xhr.responseText, xhr.status, xhr);
		}
	};
	if(_.isFunction(onProgress) && _.has(xhr, 'upload')){
		xhr.upload.onprogress = function(e){
			if(e.lengthComputable){
				onProgress(e.loaded / e.total);
			}
		};
	}
	xhr.open(method, url, true);
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

	if(method === 'POST'){
		if(typeof FormData !== 'undefined' && post_body instanceof FormData){
			//Don't set a Content-type, FormData will handle it
		}else{
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		}
		xhr.send(post_body);
	}else{
		xhr.send();
	}
	return xhr;
};

module.exports.get = function(url, callback, timeout){
	return doAjax('GET', url, null, callback, null, timeout);
};

module.exports.post = function(url, params, callback, onProgress, timeout){
	var body = null;

	if(_.isObject(params) && typeof File !== 'undefined' && _.find(_.values(params), function(param){
		return param instanceof File;
	})){
		body = new FormData();
		_.each(params, function(val, key){
			body.append(key, val);
		});
	}else if(!_.isString(params)){
		body = esUtils.phpCompatibleParams(params);
	}else{
		body = params;
	}
	return doAjax('POST', url, body, callback, onProgress, timeout);
};


//////////////////
// WEBPACK FOOTER
// ./~/ES/services/Ajax.js
// module id = 81
// module chunks = 0 1 2 3 4